import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Hero from "../components/home/Hero";
import About from "../components/home/About";
import Machines from "../components/home/Machines";
import WhyUs from "../components/home/WhyUs";
import Gallery from "../components/home/Gallery";
import Contact from "../components/home/Contact";
import Marquee from "../components/Marquee";
import { scrollToHash } from "../lib/nav";

export default function Home() {
  const location = useLocation();
  const scrollTarget = location.state?.scroll;

  useEffect(() => {
    if (!scrollTarget) return;
    const t = setTimeout(() => scrollToHash(scrollTarget), 320);
    return () => clearTimeout(t);
  }, [scrollTarget]);

  return (
    <main>
      <Hero />
      <Marquee />
      <About />
      <Machines onQuote={() => scrollToHash("iletisim")} />
      <WhyUs />
      <Gallery />
      <Contact />
    </main>
  );
}